<template>
  <section class="question checklist-answertype">
    <div class="qa-wrapper pdt-16">
      <div class="q-wrapper">
        <div class="d-flex pdb-16">
          <div class="t-subtitle2 font-b t-nowrap">Q{{ numberValue }}.</div>
          <div class="flex-grow-1 pdl-4 d-flex align-items-baseline">
            <span class="t-body1 font-r  l-spacing42">{{ checkListData.contents }}</span>
            <span
                class="t-body3 t-color-bodyGrayA  pdl-2 l-spacing42">{{ $t('3380', {str: checkListData.score}) }}</span>
          </div>
        </div>
      </div>
      <label
          id="short_answer"
          :class="validField ? 'invalid-icon-data new-mdc-field'+numberValue : 'new-mdc-field'+numberValue"
          class="mdc-text-field new-mdc-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46"
          data-mdc-auto-init="MDCTextField">
				<span class="mdc-notched-outline">
					<span class="mdc-notched-outline__leading"></span>
					<span class="mdc-notched-outline__notch">
						<span class="mdc-floating-label t-body3">{{ $t('3444') }}</span>
					</span>
					<span class="mdc-notched-outline__trailing"></span>
				</span>
        <input v-model="form.text"
               :maxlength="checkListData.charNumber"
               aria-labelledby="my-label-id"
               class="mdc-text-field__input t-body3 font-r"
               type="text"
               v-on:keyup="someHandler"/>
        <i :class="validField ? '' : 'd-none'"
           class="material-icons  mdc-text-field__icon mdc-text-field__icon--trailing "
           role="button"
           tabindex="0">report_problem</i>
      </label>
      <div class="mdc-text-field-helper-line">
        <div
            v-if="validField"
            aria-hidden="true"
            class="mdc-text-field-helper-text t-color-secondaryBtnText t-helper font-r opacity-1 l-spacing36 t-line-h-20 mdc-text-field-helper-text--validation-msg">
          {{ $t('3386') }}
        </div>
        <div class="mdc-text-field-character-counter t-helper t-color-bodyGrayA">{{ form.text ? form.text.length : 0 }}
          / {{ checkListData.charNumber }}
        </div>
      </div>
      <photo-album :documentshow="documentshow" :form="form" :numberValue="numberValue"
                   @removeImage="removeImage" @toggleDocument="toggleDocument"
                   @uploadFile="uploadFile"></photo-album>
    </div>
  </section>
</template>

<script>
/**
 * 단일답안 문항 컴포넌트(short answer type question component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {questionMixin} from '@/mixins/question.js';
import {fileMixin} from "@/mixins/file";

export default {
  props: ['numberValue', 'checkListData', 'form', 'validField'],
  data() {
    return {
      text: '',
      isSolve: false,
      documentshow: false,
      imageshow: false,
      uploadTypeImg: false
    }
  },

  components: {
    'photo-album': () => import('@/components/common/ChecklistPhotoAlbum'),
  },

  mixins: [questionMixin, fileMixin],

  mounted() {
    this.filterTextArea();
  },

  methods: {
    someHandler(evt) {
      this.validField = false;
    },

    filterTextArea() {
      const textField = new MDCTextField(document.querySelector('.new-mdc-field' + this.numberValue))
      setTimeout(() => {
        const textField = new MDCTextField(document.querySelector('.short-text-area' + this.numberValue))
      }, 500)
    },
  }
}
</script>
